import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import AppLayout from './layouts/AppLayout.vue'
import GlobalLayout from './layouts/GlobalLayout.vue'
import LoginPage from './pages/LoginPage.vue'
import DashboardPage from './pages/DashboardPage.vue'
import ParticipantsPage from './pages/ParticipantsPage.vue'
import CheckInPage from './pages/CheckInPage.vue'
import ConfirmedPage from './pages/ConfirmedPage.vue'
import ScanPage from './pages/ScanPage.vue'
import UsuariosPage from './pages/UsuariosPage.vue'
import InscricaoPage from './pages/InscricaoPage.vue'
import ConfiguracoesPage from './pages/ConfiguracoesPage.vue'
import GlobalLoginPage from './pages/GlobalLoginPage.vue'
import EncontrosListPage from './pages/EncontrosListPage.vue'
import EncontroFormPage from './pages/EncontroFormPage.vue'
import EncontroAdminsPage from './pages/EncontroAdminsPage.vue'
import NotFoundPage from './pages/NotFoundPage.vue'
import { createRouter, createWebHistory } from 'vue-router'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
import pusher from './lib/pusher'
import { isAuthenticated, getAdminRole, isGlobalRoot } from './lib/auth'
import { isApex } from './lib/encontro'

const subdomainRoutes = [
  { path: '/login', name: 'Login', component: LoginPage, meta: { public: true } },
  { path: '/scan', name: 'Scan', component: ScanPage, meta: { public: true } },
  { path: '/inscricao', name: 'Inscricao', component: InscricaoPage, meta: { public: true } },
  {
    path: '/',
    component: AppLayout,
    children: [
      { path: '', name: 'Dashboard', component: DashboardPage },
      { path: 'participants', name: 'Participants', component: ParticipantsPage },
      { path: 'check-in', name: 'CheckIn', component: CheckInPage },
      { path: 'confirmed', name: 'Confirmed', component: ConfirmedPage },
      { path: 'scanner', name: 'Scanner', component: ScanPage },
      { path: 'usuarios', name: 'Usuarios', component: UsuariosPage, meta: { roles: ['ROOT'] } },
      { path: 'configuracoes', name: 'Configuracoes', component: ConfiguracoesPage, meta: { roles: ['ROOT'] } }
    ]
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundPage, meta: { public: true } }
]

const apexRoutes = [
  { path: '/login', name: 'GlobalLogin', component: GlobalLoginPage, meta: { public: true } },
  {
    path: '/',
    component: GlobalLayout,
    children: [
      { path: '', name: 'EncontrosList', component: EncontrosListPage },
      { path: 'encontros/novo', name: 'EncontroNovo', component: EncontroFormPage },
      { path: 'encontros/:id/editar', name: 'EncontroEdit', component: EncontroFormPage },
      { path: 'encontros/:id/usuarios', name: 'EncontroAdmins', component: EncontroAdminsPage }
    ]
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundPage, meta: { public: true } }
]

const routes = isApex() ? apexRoutes : subdomainRoutes

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.public) return next()
  if (!isAuthenticated()) return next('/login')

  if (isApex()) {
    if (!isGlobalRoot()) return next('/login')
    return next()
  }

  if (Array.isArray(to.meta.roles) && to.meta.roles.length > 0) {
    const role = getAdminRole()
    if (!role || !to.meta.roles.includes(role)) return next('/')
  }
  next()
})

const pinia = createPinia()
const app = createApp(App)

app.provide('pusher', pusher)
app.use(pinia).use(router).use(VueToast)

app.mount('#app')
